function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 148,
    viewBox: "0 0 352 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.667 0C344.801 0 351.396 6.59447 351.396 14.7292C351.396 22.8639 344.801 29.4583 336.667 29.4583H252.5C260.635 29.4583 267.229 36.0528 267.229 44.1875C267.229 52.3222 260.635 58.9167 252.5 58.9167H298.792C306.926 58.9167 313.521 65.5111 313.521 73.6458C313.521 81.7805 306.926 88.375 298.792 88.375H277.384C267.127 88.375 258.812 94.9695 258.812 103.104C258.812 108.527 263.021 113.437 271.438 117.833C279.572 117.833 286.167 124.428 286.167 132.562C286.167 140.697 279.572 147.292 271.438 147.292H96.7917C88.657 147.292 82.0625 140.697 82.0625 132.562C82.0625 124.428 88.657 117.833 96.7917 117.833H14.7292C6.59447 117.833 0 111.239 0 103.104C0 94.9695 6.59447 88.375 14.7292 88.375H98.8958C107.031 88.375 113.625 81.7805 113.625 73.6458C113.625 65.5111 107.031 58.9167 98.8958 58.9167H46.2917C38.157 58.9167 31.5625 52.3222 31.5625 44.1875C31.5625 36.0528 38.157 29.4583 46.2917 29.4583H130.458C122.324 29.4583 115.729 22.8639 115.729 14.7292C115.729 6.59447 122.324 0 130.458 0H336.667ZM336.667 58.9167C344.801 58.9167 351.396 65.5111 351.396 73.6458C351.396 81.7805 344.801 88.375 336.667 88.375C328.532 88.375 321.938 81.7805 321.938 73.6458C321.938 65.5111 328.532 58.9167 336.667 58.9167Z",
    fill: "#F4F8FF",
    style: {
      fill: "#F4F8FF",
      fill: "color(display-p3 0.9583 0.9722 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.333 108.96C194.027 108.96 215.667 87.3201 215.667 60.6263C215.667 33.9325 194.027 12.293 167.333 12.293C140.64 12.293 119 33.9325 119 60.6263C119 87.3201 140.64 108.96 167.333 108.96Z",
    fill: "#F3F7FF",
    stroke: "#ACB2DA",
    style: {
      fill: "#F3F7FF",
      fill: "color(display-p3 0.9529 0.9686 1.0000)",
      fillOpacity: 1,
      stroke: "#ACB2DA",
      stroke: "color(display-p3 0.6727 0.6990 0.8542)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.589 98.1281C162.126 98.5965 164.708 98.8399 167.333 98.8583C188.449 98.8583 205.567 81.7404 205.567 60.6245C205.567 39.5085 188.449 22.3906 167.333 22.3906C161.909 22.3906 156.749 23.5202 152.074 25.557C143.951 29.0965 137.297 35.3756 133.278 43.2272C130.607 48.4458 129.1 54.3591 129.1 60.6245C129.1 66.309 130.34 71.7039 132.565 76.553C134.154 80.0149 136.244 83.1987 138.744 86.0111",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.589 98.1281C162.126 98.5965 164.708 98.8399 167.333 98.8583C188.449 98.8583 205.567 81.7404 205.567 60.6245C205.567 39.5085 188.449 22.3906 167.333 22.3906C161.909 22.3906 156.749 23.5202 152.074 25.557C143.951 29.0965 137.297 35.3756 133.278 43.2272C130.607 48.4458 129.1 54.3591 129.1 60.6245C129.1 66.309 130.34 71.7039 132.565 76.553C134.154 80.0149 136.244 83.1987 138.744 86.0111",
    stroke: "#ACB2DA",
    style: {
      stroke: "#ACB2DA",
      stroke: "color(display-p3 0.6727 0.6990 0.8542)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 96L209.657 104.657",
    stroke: "#ACB2DA",
    style: {
      stroke: "#ACB2DA",
      stroke: "color(display-p3 0.6727 0.6990 0.8542)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.258 103.259C205.527 105.99 205.527 110.417 208.258 113.148L224.252 129.142C226.983 131.873 231.41 131.873 234.141 129.142C236.872 126.411 236.872 121.984 234.141 119.253L218.147 103.259C215.416 100.528 210.989 100.528 208.258 103.259Z",
    fill: "#F1F3FF",
    stroke: "#ACB2DA",
    style: {
      fill: "#F1F3FF",
      fill: "color(display-p3 0.9451 0.9529 1.0000)",
      fillOpacity: 1,
      stroke: "#ACB2DA",
      stroke: "color(display-p3 0.6727 0.6990 0.8542)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 107L231.871 122.871",
    stroke: "white",
    style: {
      stroke: "white",
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.955 44.0335C157.955 60.7669 171.52 74.332 188.254 74.332C191.541 74.332 194.706 73.8085 197.669 72.8403C192.832 84.8456 181.072 93.32 167.333 93.32C149.276 93.32 134.639 78.6822 134.639 60.6255C134.639 44.2636 146.658 30.709 162.348 28.3086C159.561 32.8941 157.955 38.2763 157.955 44.0335Z",
    fill: "#F1F3FF",
    style: {
      fill: "#F1F3FF",
      fill: "color(display-p3 0.9451 0.9529 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.055 33.9336C166.217 33.9336 164.422 34.1143 162.686 34.459M157.442 36.0633C147.573 40.2109 140.642 49.9693 140.642 61.3465",
    stroke: "#C0D6FF",
    style: {
      stroke: "#C0D6FF",
      stroke: "color(display-p3 0.7542 0.8385 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.776 61.0257H232.98M253.901 49.8047H229.12H253.901ZM264 49.8047H260.795H264Z",
    stroke: "#C0D6FF",
    style: {
      stroke: "#C0D6FF",
      stroke: "color(display-p3 0.7542 0.8385 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.31daade99414ffad82d82e4a13d80f27.svg";
export { ForwardRef as ReactComponent };